import { Box, Grid, Stack } from "@mui/material";
import React from "react";
import styles from "./index.module.scss";
import { FaBoxesStacked } from "react-icons/fa6";
import { IoCloseOutline } from "react-icons/io5";
import { useReportsContext } from "../../../../hooks/ReportsContext";
import { FaCheck } from "react-icons/fa6";
import { MdInsertLink } from "react-icons/md";
import PersonalizedButton from "../../../../components/personalizedButton";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export default function Deliveries({ isOpen, setIsOpen }: Props) {
  const { selectedPartnership } = useReportsContext();

  return (
    <Box
      className={styles.backgroundWrapper}
      onClick={() => {
        setIsOpen(false);
      }}
    >
      <Stack
        className={styles.deliveriesModalWrapper}
        onClick={(e) => e.stopPropagation()}
      >
        <Stack direction="row" className={styles.headerModal} spacing={1}>
          <Stack direction={"row"} spacing={2} alignItems={"center"}>
            <FaBoxesStacked className={styles.headerIcon} fontSize="28px" />
            <p className={styles.headerTitle}>Entregas do produtor</p>
          </Stack>
          <IoCloseOutline
            className={styles.headerIcon}
            onClick={() => setIsOpen(false)}
          />
        </Stack>
        <Box className={styles.tasksWrapper}>
          <Stack width={"100%"} rowGap={"24px"}>
            {selectedPartnership &&
              selectedPartnership.Entregas.map((item, index) => {
                return (
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    alignItems={"center"}
                    className={styles.task}
                    key={index}
                  >
                    <Grid item xs={0.5}>
                      <Box className={styles.checkbox}>
                        {item.Status === "Concluído" && <FaCheck />}
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <p>{item.Nome_entrega}</p>
                    </Grid>
                    <Grid item xs={2.5}>
                      <Box className={styles.statusWrapper}>
                        <p
                          style={{
                            backgroundColor:
                              item.Status === "Concluído"
                                ? "#33ce60"
                                : "#c8d332",
                          }}
                        >
                          {item.Status}
                        </p>
                      </Box>
                    </Grid>

                    <Grid item xs={2}>
                      {item.Status === "Concluído" && <p>18/07/2024</p>}
                    </Grid>

                    <Grid item xs={1}>
                      {item.Link && (
                        <Box
                          className={styles.linkWrapper}
                          onClick={() => window.open(item.Link, "_blank")}
                        >
                          <MdInsertLink className={styles.linkIcon} />
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                );
              })}
          </Stack>
        </Box>
        <Box className={styles.footer}>
          <Box sx={{ width: "200px" }}>
            <PersonalizedButton
              text="Fechar"
              onClick={() => {
                setIsOpen(false);
              }}
              variant="primary"
            />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
